import { useApi } from '@/api';
import {
  ActivityCard,
  ExternalLinkIcon,
  KpiCard,
  LinkButton,
  Page,
  PageSkeleton
} from '@/components';
import UpgradeIcon from '@/components/icons/UpgradeIcon';
import UpgradeLogo from '@/components/icons/UpgradeLogo';
import { useSearchParams } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import {
  ArrowSwitchIcon,
  EtherScanPictogram,
  Flex,
  Heading
} from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';

export default function MigrationsDAIPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [data, error] = useApi({
    url: '/migrations/dai/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Flex gap="2xs" alignItems="center">
            <UpgradeLogo size="3" />
            <Heading size="1">
              <Flex gap="xs" alignItems="center">
                DAI <ArrowSwitchIcon /> USDS
                <a
                  href={`https://etherscan.io/address/0x3225737a9Bbb6473CB4a45b7244ACa2BeFdB276A`}
                  target="_blank"
                  rel="noreferrer">
                  <EtherScanPictogram size="0" />
                </a>
              </Flex>
            </Heading>
          </Flex>
        }
        actions={
          <>
            <LinkButton
              to="https://app.sky.money/?widget=upgrade&source_token=DAI"
              target="_blank">
              <Flex
                gap="3xs"
                alignItems="center"
                style={{ whiteSpace: 'nowrap' }}>
                <UpgradeIcon size="1" /> Upgrade to USDS
                <ExternalLinkIcon size="1" />
              </Flex>
            </LinkButton>
          </>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            variant="usds"
            title="USDS"
            data={data}
            field="usds_balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  iconSize: '4',
                  currency: tokensMapping('USDS')
                }
              }
            }}
          />
          <KpiCard
            title="DAI"
            variant="dai"
            data={data}
            field="dai_balance"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  iconSize: '4',
                  currency: tokensMapping('DAI')
                }
              }
            }}
          />
        </Flex>
        <HistoricTabs />
        <ActivityCard url={'/migrations/dai/activity/'} linkTo="activity" />
      </Page>
    );
  }
  return <PageSkeleton />;
}
